import React from 'react'

import { Container } from './styled'

interface Props {
  icon: React.ReactNode
}

export const ModalIcon = ({ icon }: Props) => {
  return <Container>{icon}</Container>
}
